import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full max-w-xl mb-6" }

import InputText from "primevue/inputtext";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";


export default /*#__PURE__*/_defineComponent({
  __name: 'KeywordInput',
  props: {
  modelValue: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: "키워드를 입력해주세요...",
  },
},
  emits: ["update:modelValue", "generate"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const updateModelValue = (event: Event) => {
  emit("update:modelValue", (event.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IconField), {
      class: "w-full",
      pt: { root: 'relative w-full' }
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(InputText), {
          value: props.modelValue,
          onInput: updateModelValue,
          placeholder: props.placeholder,
          class: "w-full flex-1 rounded-full h-14 pl-6 pr-14 text-lg border-2 border-primary-300 focus:border-primary-500 focus:ring-2 focus:ring-primary-500/50 dark:focus:ring-primary-400/50",
          onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.$emit('generate')), ["enter"]))
        }, null, 8, ["value", "placeholder"]),
        _createVNode(_unref(InputIcon), null, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: "pi pi-search absolute right-4 top-1/2 transform -translate-y-1/2 text-2xl text-primary-500 cursor-pointer hover:text-primary-600",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('generate')))
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})